import CryptoJS from 'crypto-js';
const setLocalStore = (key: string, data: any) => {
    const encrypted = CryptoJS.AES.encrypt(JSON.stringify(data), process.env.REACT_APP_SECRET_KEY).toString();
    localStorage.setItem(key, encrypted);
}
const getLocalStore = (key: string) => {
    const encrypted = localStorage.getItem(key);
    const decrypted = encrypted ? CryptoJS.AES.decrypt(encrypted, process.env.REACT_APP_SECRET_KEY).toString(CryptoJS.enc.Utf8) : '{}';
    return JSON.parse(decrypted);
}
const removeLocalStore = (key: string) => {
    localStorage.removeItem(key);
}
const clearLocalStore = () => {
    localStorage.clear();
}
export { setLocalStore, getLocalStore, removeLocalStore, clearLocalStore }